import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import composedMyAssignmentsContainer from "../../../containers/MyAssignmentsContainer";
import MyAssignementList from "./MyAssignementsList";
import MyAssignmentCompletedList from "./MyAssignmentCompletedList";
import MyAssignmentCancelledList from "./MyAssignmentCancelledList";
import { useEffect } from "react";
import CancelAssignments from "./CancelAssignments";
import MyAssignmentListMobile from "./MyAssignmentListMobile";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Speed Dial - Start
import Box from "@mui/material/Box";
import { connect, useDispatch } from "react-redux";
import { getDataOnRequest } from "../../../redux/actions/CommonActions";
import Input from "../../FormElements/Input";
import Dropdown from "../../FormElements/Dropdown";
import { convertToOriginalForm } from "../../../services/StringOperation";

const MyAssignmentMainComponent = ({ deviceInfo, ...props }) => {
  const [value, setValue] = React.useState(0);
  const [assignTab, setAssignTab] = useState("Assigned");
  const [showHideFilter, setShowHideFilter] = useState(false);
  const [myAssignmentsDetails, setMyAssignmentsDetails] = useState([{}]);
  const [filterAvailabilityDate, setFilterAvailabilityDate] = useState("");

  // Jo Title Start
  const [filterJobTitle, setFilterJobTitle] = useState("");
  const jobTitles = [
    ...new Set(
      props.myassignments
        .map((item) => item.cnd_assignment_job_roles)
        .filter((name) => name && name.trim() !== ""),
    ),
  ];

  // Build dropdown options
  const jobTitleOptions = [
    { name: "Choose Job Title", value: "" }, // default empty option
    ...jobTitles.map((title) => ({
      name: title ? convertToOriginalForm(title) : "",
      value: title,
    })),
  ];

  // Client Start
  const [filterClientName, setFilterClientName] = useState("");
  const clientNames = [
    ...new Set(
      props.myassignments
        .map((item) => item.clt_company_name)
        .filter((name) => name && name.trim() !== ""),
    ),
  ];

  // Build dropdown options
  const clientNameOptions = [
    { name: "Choose Client", value: "" }, // default empty option
    ...clientNames.map((title) => ({
      name: title ? convertToOriginalForm(title) : "",
      value: title,
    })),
  ];

  // Branch Start
  const [filterBranchName, setFilterBranchName] = useState("");
  const branchNames = [
    ...new Set(
      props.myassignments
        .map((item) =>
          item.clt_branch_name ? item.clt_branch_name : item.clt_company_name,
        )
        .filter((name) => name && name.trim() !== ""),
    ),
  ];

  // Build dropdown options
  const branchNameOptions = [
    { name: "Choose Branch", value: "" }, // default empty option
    ...branchNames.map((title) => ({
      name: title ? convertToOriginalForm(title) : "",
      value: title,
    })),
  ];

  // Location
  const [filterLocationName, setFilterLocationName] = useState("");
  const locationName = [
    ...new Set(
      props.myassignments
        .map((item) =>
          item.clt_branch_town
            ? item.clt_branch_town
            : item.client_address_town,
        )
        .filter((name) => name && name.trim() !== ""),
    ),
  ];

  // Build dropdown options
  const locationOptions = [
    { name: "Choose Location", value: "" }, // default empty option
    ...locationName.map((title) => ({
      name: title ? convertToOriginalForm(title) : "",
      value: title,
    })),
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.userAuth?.users_access_token) {
      // API call sirf yaha hoga jab token aur assignTab ready ho
      if (window?.location?.pathname === "/cancel-assignments") {
        dispatch(
          getDataOnRequest(
            props.userAuth.users_access_token + "/cancelAssigned",
            "GetMyAssignments",
            "SET_MYASSIGNMENTS",
          ),
        );
      } else {
        dispatch(
          getDataOnRequest(
            props.userAuth.users_access_token +
              (assignTab ? "/" + assignTab.toLowerCase() : "/assigned"),
            "GetMyAssignments",
            "SET_MYASSIGNMENTS",
          ),
        );
      }
    }
  }, [props.userAuth?.users_access_token, assignTab]);

  // Ye sirf assignments set karega jab redux se data update ho
  useEffect(() => {
    if (props.myassignments) {
      setMyAssignmentsDetails(props.myassignments);
      filterMyAssignmentDetails(
        filterAvailabilityDate,
        filterJobTitle,
        filterClientName,
        filterBranchName,
        filterLocationName,
      );
    }
  }, [props.myassignments]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const assignmentsTab = (assignTabValue = "") => {
    if (assignTabValue) {
      setAssignTab(assignTabValue);
    } else {
      setAssignTab("Assigned");
    }

    setFilterAvailabilityDate("");
    setFilterJobTitle("");
    setFilterClientName("");
    setFilterBranchName("");
    setFilterLocationName("");
  };

  const filterMyAssignmentDetails = (
    filterAvailabilityDate,
    filterJobTitle,
    filterClientName,
    filterBranchName,
    filterLocationName,
  ) => {
    if (props.myassignments) {
      const filterAssignments = props.myassignments.filter((assign) => {
        return (
          (!filterAvailabilityDate ||
            assign.cnd_assignment_availability_date ===
              filterAvailabilityDate) &&
          (!filterJobTitle ||
            assign.cnd_assignment_job_roles === filterJobTitle) &&
          (!filterClientName || assign.clt_company_name === filterClientName) &&
          (!filterBranchName || assign.clt_branch_name === filterBranchName) &&
          (!filterLocationName || assign.clt_branch_town === filterLocationName)
        );
      });

      setMyAssignmentsDetails(filterAssignments);
    }
  };

  useEffect(() => {
    filterMyAssignmentDetails(
      filterAvailabilityDate,
      filterJobTitle,
      filterClientName,
      filterBranchName,
      filterLocationName,
    );
  }, [
    filterAvailabilityDate,
    filterJobTitle,
    filterClientName,
    filterBranchName,
    filterLocationName,
  ]);

  // Print Content - Start
  const printContent = (assignTabValue = "") => {
    if (deviceInfo == "Mobile") {
      return (
        <MyAssignmentListMobile
          assignmentTypeParam={assignTabValue ? assignTabValue : "Assigned"}
          myAssignmentsDetails={myAssignmentsDetails}
        />
      );
    } else {
      return (
        <>
          <MyAssignementList
            assignmentTypeParam={assignTabValue ? assignTabValue : "Assigned"}
            myAssignmentsDetails={myAssignmentsDetails}
          />
        </>
      );
    }
  };
  // Print Content - End

  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix">
          <h5 className="font-weight-700 pull-left text-uppercase">
            My Assignments
          </h5>
        </div>
        {window.location.pathname != "/cancel-assignments" && (
          <>
            <div className="container">
              <div
                className="row border border-grey p-3 mb-4"
                style={{ borderRadius: "20px" }}
              >
                {showHideFilter === false && (
                  <>
                    <div
                      className="col-sm-12 cursor-pointer"
                      onClick={() => {
                        setShowHideFilter(
                          showHideFilter === false ? true : false,
                        );
                      }}
                    >
                      <h6
                        className="font-weight-700 mb-0"
                        style={
                          deviceInfo === "Mobile" ? { fontSize: "100%" } : {}
                        }
                      >
                        Filter Assignments{" "}
                        {assignTab
                          ? " - (" +
                            (assignTab === "Assigned"
                              ? "Upcoming"
                              : assignTab) +
                            ")"
                          : ""}
                        <i
                          className="fa fa-chevron-circle-right pull-right text-primary"
                          style={{ marginTop: "0.5rem" }}
                        />
                      </h6>
                    </div>
                  </>
                )}
                {showHideFilter && (
                  <>
                    <div className="col-sm-12">
                      <div
                        className="cursor-pointer mb-3"
                        onClick={() => {
                          setShowHideFilter(
                            showHideFilter === false ? true : false,
                          );
                        }}
                      >
                        <h6
                          className="font-weight-700 mb-0"
                          style={
                            deviceInfo === "Mobile" ? { fontSize: "100%" } : {}
                          }
                        >
                          Filter Assignments{" "}
                          {assignTab
                            ? " - (" +
                              (assignTab === "Assigned"
                                ? "Upcoming"
                                : assignTab) +
                              ")"
                            : ""}
                          <i
                            className="fa fa-chevron-circle-down text-right text-primary"
                            style={{ marginTop: "-1rem" }}
                          />
                        </h6>
                        <hr />
                      </div>
                    </div>
                    <Input
                      key={filterAvailabilityDate === "" ? "empty" : "filled"}
                      label="Assignment Date"
                      req={false}
                      value={filterAvailabilityDate || ""}
                      type="date"
                      lg={6}
                      changeHandler={(e) =>
                        setFilterAvailabilityDate(e.target.value)
                      }
                    />
                    <Dropdown
                      label="Job Title"
                      value={filterJobTitle}
                      options={jobTitleOptions}
                      changeHandler={(e) => setFilterJobTitle(e.target.value)}
                      lg={6}
                      req={false}
                    />
                    <Dropdown
                      label="Client"
                      value={filterClientName}
                      options={clientNameOptions}
                      changeHandler={(e) => setFilterClientName(e.target.value)}
                      lg={4}
                      req={false}
                    />
                    <Dropdown
                      label="Branch"
                      value={filterBranchName}
                      options={branchNameOptions}
                      changeHandler={(e) => setFilterBranchName(e.target.value)}
                      lg={4}
                      req={false}
                    />
                    <Dropdown
                      label="Location"
                      value={filterLocationName}
                      options={locationOptions}
                      changeHandler={(e) =>
                        setFilterLocationName(e.target.value)
                      }
                      lg={4}
                      req={false}
                    />
                  </>
                )}
              </div>
            </div>
            {deviceInfo == "Mobile" ? (
              <Box
                sx={{
                  flexGrow: 1,
                  // maxWidth: { xs: 320, sm: 480 },
                  bgcolor: "background.paper",
                }}
                className="mb-3"
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="visible arrows tabs example"
                  sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                      "&.Mui-disabled": { opacity: 0.3 },
                    },
                  }}
                  className=""
                >
                  <Tab
                    label="Upcoming"
                    style={{ fontSize: "80%" }}
                    onClick={(e) => assignmentsTab("Assigned")}
                  />
                  <Tab
                    label="Completed"
                    style={{ fontSize: "80%" }}
                    onClick={(e) => assignmentsTab("Completed")}
                  />
                  <Tab
                    label="Cancelled"
                    style={{ fontSize: "80%" }}
                    onClick={(e) => assignmentsTab("Cancelled")}
                  />
                </Tabs>
              </Box>
            ) : (
              <ul
                className="nav nav-tabs bg-dark p-1"
                style={{
                  borderRadius: "25px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <li className={"nav-item cursor-pointer p-2"}>
                  <a
                    className={
                      "nav-link " +
                      (assignTab == "Assigned"
                        ? "text-primary active bold"
                        : "text-white")
                    }
                    id="tab1"
                    style={{ borderRadius: "50px" }}
                    onClick={(e) => assignmentsTab("Assigned")}
                  >
                    Upcoming
                  </a>
                </li>
                <li className={"nav-item cursor-pointer p-2"}>
                  <a
                    className={
                      "nav-link " +
                      (assignTab == "Completed"
                        ? "text-primary active"
                        : "text-white")
                    }
                    onClick={(e) => assignmentsTab("Completed")}
                    id="tab2"
                    style={{ borderRadius: "50px" }}
                  >
                    Completed
                  </a>
                </li>
                <li className={"nav-item cursor-pointer p-2"}>
                  <a
                    className={
                      "nav-link " +
                      (assignTab == "Cancelled"
                        ? "text-primary active"
                        : "text-white")
                    }
                    id="tab3"
                    style={{ borderRadius: "50px" }}
                    onClick={(e) => assignmentsTab("Cancelled")}
                  >
                    Cancelled
                  </a>
                </li>
              </ul>
            )}
            {/* </div> */}

            {assignTab == "Assigned" && (
              <>
                <div id="tabFirst" className="tab-pane fade show active">
                  {/* <MyAssignementList  /> */}
                  {printContent("Assigned")}
                </div>
              </>
            )}
            {assignTab == "Completed" && (
              <>
                <div id="tabSecond" className="tab-pane show fade">
                  {/* <MyAssignmentCompletedList /> */}
                  {printContent("Completed")}
                </div>
              </>
            )}

            {assignTab == "Cancelled" && (
              <>
                <div id="tabThird" className="tab-pane show fade">
                  {/* <MyAssignmentCancelledList /> */}
                  {printContent("Cancelled")}
                </div>
              </>
            )}
          </>
        )}

        {window.location.pathname == "/cancel-assignments" && (
          <>
            <CancelAssignments
              assignmentTypeParam={"Assigned"}
              myAssignmentsDetails={myAssignmentsDetails}
              deviceInfo={deviceInfo}
            />
          </>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    myassignments: state.myassignments.myassignments,
    userAuth: state.auth.authUserData,
  };
};

export default connect(mapStateToProps)(MyAssignmentMainComponent);
